<template>
  <v-card>
    <v-card-title>
      List of Active Care Users ({{ items.length }})
      <v-btn small icon @click.native="dataRefresh">
        <v-icon>refresh</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search">
      </v-text-field>
    </v-card-title>
    <v-progress-linear
      :indeterminate="true"
      :active="showProgress">
    </v-progress-linear>
    <v-data-table
      v-bind:headers="headers"
      v-bind:items="items"
      v-bind:search="search"
      v-bind:rows-per-page-items="rowsPerPage">
      <template slot="items" slot-scope="props">
        <td class="layout px-0" v-if="shouldDisplay('view_care_user_from_list')">
          <v-btn top small icon :to="{name: 'careUserEdit', params: { id: props.item.careUserId }}" v-if="shouldDisplay('view_care_user_from_list')">
            <v-icon top small color="grey">more_horiz</v-icon>
          </v-btn>
          <v-btn top small icon :to="{name: 'dashboard'}" v-if="shouldDisplay('view_dashborad_from_user_list')">
            <v-icon top small color="grey">dashboard</v-icon>
          </v-btn></td>
        <td class="text-xs-left">{{ props.item.careGroup.name }}</td>
        <td class="text-xs-left">{{ props.item.firstName }}</td>
        <td class="text-xs-left">{{ props.item.lastName }}</td>
        <td class="text-xs-left">{{ watchOneLabel(props.item) }}</td>
        <td class="text-xs-left">{{ watchTwoLabel(props.item) }}</td>
        <td class="text-xs-left">{{ props.item.address.unitNumber }}</td>
        <td class="text-xs-left">
          <v-expansion-panel popout>
            <v-expansion-panel-content>
              <div slot="header">{{ props.item.address.streetAddress}}</div>
              <v-card class="grey lighten-4 pl-2, pr-2, mt-1, mb-1">
                <v-card-text>
                  {{ props.item.address.city}}
                </v-card-text>
                <v-card-text>
                  {{ props.item.address.province}}
                </v-card-text>
                <v-card-text>
                  {{ props.item.address.postalCode}}
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </td>
        <td class="text-xs-left">{{ props.item.phone.phone }}</td>
        <td class="text-xs-left">{{ props.item.Email1.email }}</td>
        <td class="text-xs-left">{{ props.item.Email2.email }}</td>
        <td class="text-xs-left">
          <v-layout row>
            <v-expansion-panel popout>
              <v-expansion-panel-content>
                <div slot="header">{{ props.item.Emergency1.firstName }} {{ props.item.Emergency1.lastName }}</div>
                <v-card class="grey lighten-4 pl-2, pr-2, mt-1, mb-1">
                  <v-card-text>
                    Phone: {{ props.item.Emergency1.phone.phone}}
                  </v-card-text>
                  <v-card-text>
                    Email: {{ props.item.Emergency1.email.email}}
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel popout>
              <v-expansion-panel-content>
                <div slot="header">{{ props.item.Emergency2.firstName }} {{ props.item.Emergency2.lastName }}</div>
                <v-card class="grey lighten-4 pl-2, pr-2, mt-1, mb-1">
                  <v-card-text>
                    Phone: {{ props.item.Emergency2.phone.phone}}
                  </v-card-text>
                  <v-card-text>
                    Email: {{ props.item.Emergency2.email.email}}
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-layout>
        </td>
        <td class="text-xs-left">
          <v-expansion-panel popout>
            <v-expansion-panel-content>
              <div slot="header">{{ props.item.Location.firstName }} {{ props.item.Location.lastName }}</div>
              <v-card class="grey lighten-4 pl-2, pr-2, mt-1, mb-1">
                <v-card-text>
                  Phone: {{ props.item.Location.phone.phone}}
                </v-card-text>
                <v-card-text>
                  Email: {{ props.item.Location.email.email}}
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </td>
        <td class="text-xs-right">{{ props.item.service.name }}</td>
        <td class="text-xs-left" v-if="shouldDisplay('view_care_user_from_list')">
          <v-dialog v-model="dialog" max-width="500px" hide-overlay lazy>
            <v-btn small icon slot="activator" @click.native="
              deleteId = props.item.careUserId,
              deleteFirstName = props.item.firstName,
              deleteLastName = props.item.lastName
              dialog = true">
              <v-icon small color="grey">delete</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                Do you want to set the care user
                <div class="red--text subheading">
                    {{ deleteFirstName }}
                    {{ deleteLastName }}
                </div>to inactive
              </v-card-text>
              <v-spacer></v-spacer>
              <v-btn dark color="blue darken-1"
                @click.native="dialog = false">CANCEL</v-btn>
              <v-btn dark color="red darken-1"
              @click.native="inactivate()">CONFIRM INACTIVE</v-btn>
            </v-card>
          </v-dialog>
        </td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <div class="red white--text subheading">{{ errMsg }}</div>
  </v-card>
</template>

<script>
  import mixins from '@/mixins.js'
  import CareUserService from '@/services/CareUserService'

  export default {
    data() {
      return {
        errMsg: '',
        deleteId: 0,
        deleteFirstName: '',
        deleteLastName: '',
        showProgress: true,
        dialog: false,
        tmp: '',
        search: '',
        selected: [],
        pagination: {},
        rowsPerPage: [
          10,
          20,
          {"text": "All", "value": -1}
        ],
        headers: [
          {
            text: 'Edit',
            align: 'left',
            sortable: false,
          },
          { text: 'Care Group Name', align: 'left', value: 'careGroup.name' },
          { text: 'First Name', align: 'left', value: 'firstName' },
          { text: 'Last Name', align: 'left', value: 'lastName' },
          { text: 'Watch 1', align: 'left', sortable: false },
          { text: 'Watch 2', align: 'left', sortable: false },
          { text: 'Unit', align: 'left', value: 'address.unitNumber' },
          { text: 'Address', align: 'left', value: 'address.streetAddress' },
          { text: 'Phone', align: 'left', value: 'phone.phone' },
          { text: 'Email 1', align: 'left', value: 'Email1.email' },
          { text: 'Email 2', align: 'left', value: 'Email2.email' },
          {
            text: 'Emergency Contacts',
            align: 'left',
            value: 'Emergency.firstName'
          },
          {
            text: 'Care Location Contact',
            align: 'left',
            value: 'Location.firstName'
          },
          { text: 'Service', align: 'left', value: 'service.name' },
          { text: 'De-activate',
            align: 'left',
            sortable: false
          }
        ],
        items: []
      }
    },
    mixins: [mixins],
    async mounted() {
      try {
        this.dialog = false
        this.errMsg = ''
        this.showProgress = true
        this.items = (await CareUserService.index()).data
        if (!this.shouldDisplay('view_care_user_from_list')) {
          this.headers.splice(0,1)
          this.headers.splice(13,1)
        }
        this.showProgress = false
      } catch (error) {
        this.showProgress = false
        this.errMsg = this.handleError(error)
      }
    },
    methods: {
      async inactivate() {
        try {
          this.errMsg = ''
          this.dialog = false
          const response = await CareUserService.state({
            careUserId: this.deleteId,
            state: 1
          })
          this.showProgress = true
          this.items = (await CareUserService.index()).data
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      },
      async dataRefresh() {
        try {
          this.errMsg = ''
          this.dialog = false
          this.showProgress = true
          this.items = (await CareUserService.index()).data
          if (!this.shouldDisplay('view_care_user_from_list')) {
            this.headers.splice(0,1)
            this.headers.splice(13,1)
          }
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      },
      watchOneLabel: function(item) {
        if (item) {
          if (item.devices) {
            if (item.devices[0]) {
              return item.devices[0].serial
            } else {
              return null
            }
          } else {
            return null
          }
        } else {
          return null
        }
      },
      watchTwoLabel: function(item) {
        if (item) {
          if (item.devices) {
            if (item.devices[1]) {
              return item.devices[1].serial
            } else {
              return null
            }
          } else {
            return null
          }
        } else {
          return null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CareUser/CareUserList.vue